import React, { useEffect } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CTA } from '../components/CTA';
import { Testimonial } from '../components/Testimonial';
import { ResultsCarousel } from '../components/ResultsCarousel';
import { FAQItem } from '../components/FAQItem';
import { CheckCircleIcon, ShieldIcon, ClockIcon, HeartIcon, FlameIcon, LeafIcon, DropletIcon } from 'lucide-react';
export const ProductPage = () => {
  // Add useEffect to scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="bg-white min-h-screen w-full" data-id="element-337">
      <Header data-id="element-338" />
      <main className="max-w-4xl mx-auto px-4 py-6" data-id="element-339">
        {/* Hero Section */}
        <section className="mb-12" data-id="element-340">
          <div className="flex flex-col md:flex-row md:space-x-8" data-id="element-341">
            <div className="mb-6 md:mb-0 md:w-1/2" data-id="element-342">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i6GbcXQuMUGYo2fwmgxqKz/20250826_0317_Hair_Mask_Display_remix_01k3j2j2q0fes9f4tpqw0z7jcr.png" alt="QISS Moleculair Herstel Haarmasker product met druppelaar" className="w-full rounded-lg shadow-md" data-id="element-343" />
            </div>
            <div className="md:w-1/2" data-id="element-344">
              <div className="bg-pink-50 text-pink-800 text-sm font-medium px-3 py-1 rounded-full inline-block mb-3" data-id="element-345">
                BESTSELLER
              </div>
              <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-346">
                QISS Moleculair Herstel Haarmasker
              </h1>
              <div className="flex items-center mb-4" data-id="element-347">
                <div className="flex" data-id="element-348">
                  {[...Array(5)].map((_, i) => <svg key={i} className="w-5 h-5 text-yellow-400 fill-current" viewBox="0 0 24 24" data-id="element-349">
                      <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-350" />
                    </svg>)}
                </div>
                <span className="ml-2 text-gray-600" data-id="element-351">4,9 (2.384 reviews)</span>
              </div>
              <div className="mb-4" data-id="element-352">
                <span className="text-3xl font-bold text-gray-900" data-id="element-353">€39,95</span>
                <span className="ml-2 text-gray-500 line-through" data-id="element-354">€59,95</span>
                <span className="ml-2 bg-green-100 text-green-800 text-sm font-medium px-2 py-0.5 rounded" data-id="element-355">
                  BESPAAR 33%
                </span>
              </div>
              <p className="text-gray-700 mb-6" data-id="element-356">
                De revolutionaire haarherstelbehandeling die beschadigd, ouder
                wordend haar in slechts enkele minuten transformeert tot
                zijdezachte, jeugdige lokken.
              </p>
              <CTA text="In Winkelwagen" destination="https://get.myhealthbeam.com/QISS/Hair/MolecularRepairMask/secure_checkout-1756400194976332-1756406025480233" className="mb-4" eventName="InitiateCheckout" eventParams={{
              content_type: 'product',
              content_ids: ['QISS-hair-mask'],
              currency: 'EUR',
              value: 39.95,
              num_items: 1
            }} data-id="element-357" />
              <div className="flex justify-between text-sm text-gray-600" data-id="element-358">
                <div className="flex items-center" data-id="element-359">
                  <ShieldIcon className="w-4 h-4 mr-1" data-id="element-360" />
                  <span data-id="element-361">60-Dagen Garantie</span>
                </div>
                <div className="flex items-center" data-id="element-362">
                  <ClockIcon className="w-4 h-4 mr-1" data-id="element-363" />
                  <span data-id="element-364">Snelle Verzending</span>
                </div>
                <div className="flex items-center" data-id="element-365">
                  <HeartIcon className="w-4 h-4 mr-1" data-id="element-366" />
                  <span data-id="element-367">Dierproefvrij</span>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Problem Section */}
        <section className="mb-12" data-id="element-368">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-369">
            Het Probleem met Ouder Wordend Haar
          </h2>
          <div className="bg-gray-50 p-6 rounded-lg mb-6" data-id="element-370">
            <p className="text-gray-700 mb-4" data-id="element-371">
              Na je 35e verandert je haar drastisch. De productie van
              natuurlijke oliën neemt af, eiwitstructuren verzwakken en
              omgevingsschade stapelt zich op, wat leidt tot:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6" data-id="element-372">
              <div className="bg-white p-4 rounded-lg shadow-sm text-center" data-id="element-373">
                <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-374">
                  <DropletIcon className="w-6 h-6 text-pink-600" data-id="element-375" />
                </div>
                <h3 className="font-medium text-gray-900 mb-1" data-id="element-376">Vochtverlies</h3>
                <p className="text-sm text-gray-700" data-id="element-377">
                  Verminderde natuurlijke olieproductie leidt tot droge, broze
                  strengen
                </p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow-sm text-center" data-id="element-378">
                <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-379">
                  <FlameIcon className="w-6 h-6 text-pink-600" data-id="element-380" />
                </div>
                <h3 className="font-medium text-gray-900 mb-1" data-id="element-381">
                  Structurele Schade
                </h3>
                <p className="text-sm text-gray-700" data-id="element-382">
                  Jaren van styling en chemische behandelingen breken de
                  haarstructuur af
                </p>
              </div>
              <div className="bg-white p-4 rounded-lg shadow-sm text-center" data-id="element-383">
                <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-384">
                  <LeafIcon className="w-6 h-6 text-pink-600" data-id="element-385" />
                </div>
                <h3 className="font-medium text-gray-900 mb-1" data-id="element-386">
                  Eiwituitputting
                </h3>
                <p className="text-sm text-gray-700" data-id="element-387">
                  Leeftijdsgerelateerd verlies van essentiële eiwitten maakt
                  haar dunner en zwakker
                </p>
              </div>
            </div>
          </div>
          <p className="text-gray-700" data-id="element-388">
            De meeste haarproducten pakken alleen de symptomen aan, niet de
            hoofdoorzaken van ouder wordend haar. Ze bedekken je strengen met
            siliconen en weekmakers die wegspoelen, waardoor je haar net zo
            beschadigd achterblijft als voorheen.
          </p>
        </section>
        {/* Unique Mechanism Section */}
        <section className="mb-12" data-id="element-389">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-390">
            Onze Unieke Drievoudige Hersteltechnologie
          </h2>
          <div className="mb-6" data-id="element-391">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vqRWDrF3vH8MtqRw6ZM7Cu/20250826_0317_Hair_Mask_Display_remix_01k3j2j2ptfnptfe7a5nzsma79.png" alt="QISS Moleculair Herstel Haarmasker product" className="w-full h-48 object-contain rounded-lg" data-id="element-392" />
          </div>
          <p className="text-gray-700 mb-6" data-id="element-393">
            In tegenstelling tot conventionele maskers die alleen de oppervlakte
            bedekken, werkt QISS op drie niveaus tegelijk:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6" data-id="element-394">
            <div className="bg-white border border-pink-100 rounded-lg p-5 shadow-sm" data-id="element-395">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mb-4" data-id="element-396">
                <span className="text-2xl font-bold text-pink-600" data-id="element-397">1</span>
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-398">Cuticula Herstel</h3>
              <p className="text-sm text-gray-700" data-id="element-399">
                Ons gepatenteerde ceramidecomplex verzegelt en herstelt de
                beschermende buitenlaag van het haar, voorkomt vochtverlies en
                beschermt tegen omgevingsschade.
              </p>
            </div>
            <div className="bg-white border border-pink-100 rounded-lg p-5 shadow-sm" data-id="element-400">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mb-4" data-id="element-401">
                <span className="text-2xl font-bold text-pink-600" data-id="element-402">2</span>
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-403">Eiwitversterking</h3>
              <p className="text-sm text-gray-700" data-id="element-404">
                Gehydrolyseerde keratine-eiwitten dringen diep in de
                haarschacht, herbouwen beschadigde gebieden van binnenuit en
                herstellen structurele integriteit.
              </p>
            </div>
            <div className="bg-white border border-pink-100 rounded-lg p-5 shadow-sm" data-id="element-405">
              <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center mb-4" data-id="element-406">
                <span className="text-2xl font-bold text-pink-600" data-id="element-407">3</span>
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-408">
                Cellulaire Verjonging
              </h3>
              <p className="text-sm text-gray-700" data-id="element-409">
                Ons exclusieve botanische stamcelextract stimuleert de hoofdhuid
                en follikels, bevordert gezondere haargroei en verbetert de
                algehele haarkwaliteit.
              </p>
            </div>
          </div>
        </section>
        {/* Proof Section */}
        <section className="mb-12" data-id="element-410">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-411">
            Klinisch Bewezen Resultaten
          </h2>
          <div className="bg-gray-50 p-6 rounded-lg mb-6" data-id="element-412">
            <div className="grid grid-cols-2 gap-4 text-center" data-id="element-413">
              <div data-id="element-414">
                <div className="text-3xl font-bold text-pink-600" data-id="element-415">94%</div>
                <p className="text-sm text-gray-700" data-id="element-416">
                  Vermindering in breuk na 2 weken
                </p>
              </div>
              <div data-id="element-417">
                <div className="text-3xl font-bold text-pink-600" data-id="element-418">87%</div>
                <p className="text-sm text-gray-700" data-id="element-419">Toename in haarsterkte</p>
              </div>
              <div data-id="element-420">
                <div className="text-3xl font-bold text-pink-600" data-id="element-421">91%</div>
                <p className="text-sm text-gray-700" data-id="element-422">
                  Rapporteerde verbeterde glans en luister
                </p>
              </div>
              <div data-id="element-423">
                <div className="text-3xl font-bold text-pink-600" data-id="element-424">89%</div>
                <p className="text-sm text-gray-700" data-id="element-425">
                  Vermindering in gespleten punten
                </p>
              </div>
            </div>
          </div>
          <p className="text-gray-700 italic text-center" data-id="element-426">
            *Gebaseerd op een klinische studie van 156 vrouwen van 35-65 jaar
            over een periode van 30 dagen
          </p>
        </section>
        {/* What's Inside Section */}
        <section className="mb-12" data-id="element-427">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-428">
            Wat Zit Erin
          </h2>
          <div className="space-y-4" data-id="element-429">
            <div className="flex" data-id="element-430">
              <CheckCircleIcon className="w-6 h-6 text-pink-600 mr-2 flex-shrink-0" data-id="element-431" />
              <div data-id="element-432">
                <h3 className="font-bold text-gray-900" data-id="element-433">
                  Gehydrolyseerd Keratinecomplex
                </h3>
                <p className="text-gray-700" data-id="element-434">
                  Herbouwt beschadigde haarstructuur van binnenuit
                </p>
              </div>
            </div>
            <div className="flex" data-id="element-435">
              <CheckCircleIcon className="w-6 h-6 text-pink-600 mr-2 flex-shrink-0" data-id="element-436" />
              <div data-id="element-437">
                <h3 className="font-bold text-gray-900" data-id="element-438">
                  Ceramide-3 & Ceramide-6
                </h3>
                <p className="text-gray-700" data-id="element-439">
                  Verzegelt en herstelt de beschermende cuticula-laag van het
                  haar
                </p>
              </div>
            </div>
            <div className="flex" data-id="element-440">
              <CheckCircleIcon className="w-6 h-6 text-pink-600 mr-2 flex-shrink-0" data-id="element-441" />
              <div data-id="element-442">
                <h3 className="font-bold text-gray-900" data-id="element-443">
                  Argan & Marula Oliën
                </h3>
                <p className="text-gray-700" data-id="element-444">
                  Voeden diep en herstellen vocht zonder het haar te verzwaren
                </p>
              </div>
            </div>
            <div className="flex" data-id="element-445">
              <CheckCircleIcon className="w-6 h-6 text-pink-600 mr-2 flex-shrink-0" data-id="element-446" />
              <div data-id="element-447">
                <h3 className="font-bold text-gray-900" data-id="element-448">
                  Zwitsers Appel Stamcelextract
                </h3>
                <p className="text-gray-700" data-id="element-449">
                  Stimuleert celvernieuwing voor gezondere haargroei
                </p>
              </div>
            </div>
            <div className="flex" data-id="element-450">
              <CheckCircleIcon className="w-6 h-6 text-pink-600 mr-2 flex-shrink-0" data-id="element-451" />
              <div data-id="element-452">
                <h3 className="font-bold text-gray-900" data-id="element-453">Hyaluronzuur</h3>
                <p className="text-gray-700" data-id="element-454">
                  Zorgt voor intense hydratatie en volume
                </p>
              </div>
            </div>
          </div>
          <div className="mt-6 p-4 bg-green-50 rounded-lg" data-id="element-455">
            <p className="text-green-800 text-sm" data-id="element-456">
              <strong data-id="element-457">Wat er NIET in zit:</strong> Siliconen, Parabenen,
              Sulfaten, Ftalaten, Kunstmatige Kleurstoffen of Synthetische
              Geurstoffen
            </p>
          </div>
        </section>
        {/* How to Use Section */}
        <section className="mb-12" data-id="element-458">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-459">
            Gebruiksaanwijzing
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-5 gap-4" data-id="element-460">
            <div className="bg-white border border-gray-100 rounded-lg p-4 shadow-sm text-center" data-id="element-461">
              <div className="w-12 h-12 rounded-full bg-pink-100 flex items-center justify-center text-pink-700 font-bold mx-auto mb-3" data-id="element-462">
                1
              </div>
              <p className="text-sm text-gray-700" data-id="element-463">
                Aanbrengen op schoon, vochtig haar, focus op lengtes en punten
              </p>
            </div>
            <div className="bg-white border border-gray-100 rounded-lg p-4 shadow-sm text-center" data-id="element-464">
              <div className="w-12 h-12 rounded-full bg-pink-100 flex items-center justify-center text-pink-700 font-bold mx-auto mb-3" data-id="element-465">
                2
              </div>
              <p className="text-sm text-gray-700" data-id="element-466">
                Zachtjes inmasseren voor gelijkmatige verdeling
              </p>
            </div>
            <div className="bg-white border border-gray-100 rounded-lg p-4 shadow-sm text-center" data-id="element-467">
              <div className="w-12 h-12 rounded-full bg-pink-100 flex items-center justify-center text-pink-700 font-bold mx-auto mb-3" data-id="element-468">
                3
              </div>
              <p className="text-sm text-gray-700" data-id="element-469">
                10-15 minuten laten inwerken (tot 30 minuten voor intensief
                herstel)
              </p>
            </div>
            <div className="bg-white border border-gray-100 rounded-lg p-4 shadow-sm text-center" data-id="element-470">
              <div className="w-12 h-12 rounded-full bg-pink-100 flex items-center justify-center text-pink-700 font-bold mx-auto mb-3" data-id="element-471">
                4
              </div>
              <p className="text-sm text-gray-700" data-id="element-472">
                Grondig uitspoelen met warm water
              </p>
            </div>
            <div className="bg-white border border-gray-100 rounded-lg p-4 shadow-sm text-center" data-id="element-473">
              <div className="w-12 h-12 rounded-full bg-pink-100 flex items-center justify-center text-pink-700 font-bold mx-auto mb-3" data-id="element-474">
                5
              </div>
              <p className="text-sm text-gray-700" data-id="element-475">
                Gebruik 1-2 keer per week voor optimale resultaten
              </p>
            </div>
          </div>
        </section>
        {/* Results/Testimonials Section */}
        <section className="mb-12" data-id="element-476">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-477">
            Echte Resultaten van Echte Vrouwen
          </h2>
          <div className="grid gap-6 md:grid-cols-2 mb-8" data-id="element-478">
            <Testimonial quote="Mijn haar was zo beschadigd door jaren van kleuren. Na slechts 3 behandelingen met QISS is het verschil ongelooflijk. Mijn haar voelt weer als zijde aan!" author="Elisabeth, 47" image="https://uploadthingy.s3.us-west-1.amazonaws.com/sQSxxqoMogD8Hs8nASJ8bt/08_testimonial-sarah_400x400.jpg" data-id="element-479" />
            <Testimonial quote="Ik was sceptisch over nog een haarproduct, maar dit is echt waar. Mijn kapper vroeg wat ik anders doe omdat mijn haar er nu zo gezond uitziet." author="Deborah, 53" image="https://uploadthingy.s3.us-west-1.amazonaws.com/tow83n4pxxBvEczYfPLy4d/09_testimonial-jennifer_400x400.jpg" data-id="element-480" />
          </div>
          <div className="text-center" data-id="element-481">
            <ResultsCarousel className="max-w-2xl mx-auto mb-4" variant="product" data-id="element-482" />
            <p className="text-sm text-gray-600 italic" data-id="element-483">
              Werkelijke voor & na resultaten na 4 weken behandeling (onbewerkt)
            </p>
          </div>
        </section>
        {/* Value/Comparison Section */}
        <section className="mb-12" data-id="element-484">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-485">
            Waarom Kiezen voor QISS?
          </h2>
          <div className="overflow-x-auto" data-id="element-486">
            <table className="w-full border-collapse" data-id="element-487">
              <thead data-id="element-488">
                <tr data-id="element-489">
                  <th className="p-3 text-left bg-gray-50" data-id="element-490"></th>
                  <th className="p-3 text-center bg-pink-50 text-pink-800 font-bold" data-id="element-491">
                    QISS
                  </th>
                  <th className="p-3 text-center bg-gray-50" data-id="element-492">
                    Salonbehandelingen
                  </th>
                  <th className="p-3 text-center bg-gray-50" data-id="element-493">Andere Maskers</th>
                </tr>
              </thead>
              <tbody data-id="element-494">
                <tr className="border-b border-gray-200" data-id="element-495">
                  <td className="p-3 font-medium" data-id="element-496">Diepe Hersteltechnologie</td>
                  <td className="p-3 text-center text-green-600" data-id="element-497">✓</td>
                  <td className="p-3 text-center text-green-600" data-id="element-498">✓</td>
                  <td className="p-3 text-center text-red-600" data-id="element-499">✗</td>
                </tr>
                <tr className="border-b border-gray-200" data-id="element-500">
                  <td className="p-3 font-medium" data-id="element-501">
                    Geformuleerd voor 35+ Haar
                  </td>
                  <td className="p-3 text-center text-green-600" data-id="element-502">✓</td>
                  <td className="p-3 text-center text-red-600" data-id="element-503">✗</td>
                  <td className="p-3 text-center text-red-600" data-id="element-504">✗</td>
                </tr>
                <tr className="border-b border-gray-200" data-id="element-505">
                  <td className="p-3 font-medium" data-id="element-506">
                    Vrij van Schadelijke Chemicaliën
                  </td>
                  <td className="p-3 text-center text-green-600" data-id="element-507">✓</td>
                  <td className="p-3 text-center text-red-600" data-id="element-508">✗</td>
                  <td className="p-3 text-center text-red-600" data-id="element-509">✗</td>
                </tr>
                <tr className="border-b border-gray-200" data-id="element-510">
                  <td className="p-3 font-medium" data-id="element-511">Gemak</td>
                  <td className="p-3 text-center text-green-600" data-id="element-512">✓</td>
                  <td className="p-3 text-center text-red-600" data-id="element-513">✗</td>
                  <td className="p-3 text-center text-green-600" data-id="element-514">✓</td>
                </tr>
                <tr data-id="element-515">
                  <td className="p-3 font-medium" data-id="element-516">Kosten per Behandeling</td>
                  <td className="p-3 text-center font-bold text-pink-800" data-id="element-517">
                    €9,99
                  </td>
                  <td className="p-3 text-center" data-id="element-518">€80-150</td>
                  <td className="p-3 text-center" data-id="element-519">€15-25</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
        {/* Guarantee Section */}
        <section className="mb-12" data-id="element-520">
          <div className="bg-pink-50 p-6 rounded-lg text-center" data-id="element-521">
            <ShieldIcon className="w-12 h-12 text-pink-600 mx-auto mb-3" data-id="element-522" />
            <h2 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-523">
              Onze 60-Dagen Geld-Terug Garantie
            </h2>
            <p className="text-gray-700 mb-4" data-id="element-524">
              We zijn zo overtuigd dat je van je resultaten zult houden dat we
              een volledige 60-dagen tevredenheidsgarantie bieden. Als je geen
              drastische verbetering ziet in de gezondheid, glans en
              handelbaarheid van je haar, stuur het product dan gewoon terug
              voor een volledige terugbetaling — geen vragen gesteld.
            </p>
            <p className="font-medium text-pink-800" data-id="element-525">
              Probeer QISS vandaag nog risicovrij!
            </p>
          </div>
        </section>
        {/* FAQ Section */}
        <section className="mb-12" data-id="element-526">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-527">
            Veelgestelde Vragen
          </h2>
          <div className="space-y-1" data-id="element-528">
            <FAQItem question="Hoe snel zie ik resultaten?" answer="De meeste vrouwen merken al na het eerste gebruik een significante verbetering, waarbij het haar zachter aanvoelt en meer glanst. Voor meer drastisch herstel van beschadigd haar, levert consistent gebruik gedurende 2-4 weken de meest transformerende resultaten." data-id="element-529" />
            <FAQItem question="Werkt dit voor gekleurd of chemisch behandeld haar?" answer="Absoluut! QISS is speciaal geformuleerd om schade door kleuring, permanent en andere chemische behandelingen te herstellen. Het is kleurveilig en helpt zelfs de levensduur van je kleur te verlengen door de gezondheid van je haar te verbeteren." data-id="element-530" />
            <FAQItem question="Is het geschikt voor alle haartypes?" answer="Ja, QISS werkt prachtig op alle haartypes en texturen. De formule is gebalanceerd om diep herstel te bieden zonder fijn haar te verzwaren of dikker haar onvoldoende te voeden." data-id="element-531" />
            <FAQItem question="Hoeveel behandelingen zitten er in één pot?" answer="Elke pot bevat voldoende product voor ongeveer 8-10 behandelingen, afhankelijk van je haarlengte en dikte. Voor de meeste vrouwen die het 1-2 keer per week gebruiken, gaat één pot ongeveer 1-2 maanden mee." data-id="element-532" />
            <FAQItem question="Bevat het dierlijke ingrediënten?" answer="Nee, QISS is 100% veganistisch en dierproefvrij. We testen nooit op dieren en alle ingrediënten worden ethisch verantwoord verkregen." data-id="element-533" />
          </div>
        </section>
        {/* Easy To Use Section */}
        <section className="mb-12" data-id="element-534">
          <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-535">
            Eindelijk, Een Behandeling Die Bij Je Leven Past
          </h2>
          <div className="bg-gray-50 p-5 rounded-lg mb-5" data-id="element-536">
            <h3 className="text-lg font-semibold text-gray-800 mb-2" data-id="element-537">
              Eenvoudige 5-Minuten Oplossing
            </h3>
            <div className="space-y-2 text-gray-700" data-id="element-538">
              <p data-id="element-539">
                Je hebt geen tijd voor ingewikkelde routines. QISS werkt in 5
                minuten, twee keer per week.
              </p>
              <p data-id="element-540">
                Geen salonafspraken die je zaterdag opslokken. Geen
                8-productsystemen die je douche volproppen. Eén behandeling die
                echt werkt.
              </p>
              <p className="font-medium" data-id="element-541">
                Breng het aan op vochtig haar, laat 5 minuten inwerken, spoel
                uit. Dat is alles.
              </p>
            </div>
          </div>
          <div className="flex flex-col md:flex-row md:space-x-4 my-5" data-id="element-542">
            <div className="md:w-1/3 mb-4 md:mb-0" data-id="element-543">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ggSdQwCjtwEPRtp2R171Gs/Gemini_Generated_Image_o1cifbo1cifbo1ci.jpg" alt="Professionele salon met stylisten die haarbehandelingen geven" className="w-full h-40 object-cover rounded-lg" data-id="element-544" />
            </div>
            <div className="md:w-2/3" data-id="element-545">
              <p className="text-gray-700 mb-3" data-id="element-546">
                In tegenstelling tot die andere behandelingen die je haar stijf
                laten aanvoelen of je verplichten om conditioner over te slaan
                (serieus, K18?), laat QISS je haar ongelooflijk zacht en
                handelbaar aanvoelen.
              </p>
              <p className="text-gray-700 font-medium" data-id="element-547">
                De waarde is onmiskenbaar. Eén fles vervangt je hele
                herstelroutine en kost minder dan een enkele salon
                keratinebehandeling. De meeste van onze klanten merken dat één
                fles 3-4 maanden meegaat bij regelmatig gebruik.
              </p>
            </div>
          </div>
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/onWbzwi8nb8DGVaCPj5DLG/11_before-after_1200x800.jpg" alt="Vrouw met prachtig, gezond haar na behandeling" className="w-full h-48 object-cover rounded-lg mt-5" data-id="element-548" />
        </section>
        {/* Final CTA Section */}
        <section className="mb-8 text-center" data-id="element-549">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-550">
            Klaar om Je Haar te Transformeren?
          </h2>
          <p className="text-lg text-gray-700 mb-6" data-id="element-551">
            Sluit je aan bij duizenden vrouwen die het geheim hebben ontdekt
            voor natuurlijk mooi, gezond haar op elke leeftijd.
          </p>
          <div className="max-w-md mx-auto" data-id="element-552">
            <div className="mb-4 bg-gray-50 p-4 rounded-lg" data-id="element-553">
              <div className="flex justify-between mb-2" data-id="element-554">
                <span className="font-medium" data-id="element-555">Normale Prijs:</span>
                <span className="text-gray-500 line-through" data-id="element-556">€59,95</span>
              </div>
              <div className="flex justify-between mb-2" data-id="element-557">
                <span className="font-medium" data-id="element-558">Prijs Vandaag:</span>
                <span className="font-bold" data-id="element-559">€39,95</span>
              </div>
              <div className="flex justify-between" data-id="element-560">
                <span className="font-medium" data-id="element-561">Je Bespaart:</span>
                <span className="text-green-600 font-bold" data-id="element-562">€20,00 (33%)</span>
              </div>
            </div>
            <CTA text="In Winkelwagen - €39,95" destination="https://get.myhealthbeam.com/QISS/Hair/MolecularRepairMask/secure_checkout-1756400194976332-1756406025480233" eventName="InitiateCheckout" eventParams={{
            content_type: 'product',
            content_ids: ['QISS-hair-mask'],
            currency: 'EUR',
            value: 39.95,
            num_items: 1
          }} data-id="element-563" />
            <p className="mt-2 text-sm text-gray-600" data-id="element-564">
              Gratis verzending op alle bestellingen. 60-dagen geld-terug
              garantie.
            </p>
          </div>
        </section>
      </main>
      <Footer data-id="element-565" />
      {/* Sticky CTA for mobile */}
      <div className="md:hidden" data-id="element-566">
        <CTA text="In Winkelwagen - €39,95" destination="https://get.myhealthbeam.com/QISS/Hair/MolecularRepairMask/secure_checkout-1756400194976332-1756406025480233" isSticky={true} eventName="InitiateCheckout" eventParams={{
        content_type: 'product',
        content_ids: ['QISS-hair-mask'],
        currency: 'EUR',
        value: 39.95,
        num_items: 1
      }} data-id="element-567" />
      </div>
    </div>;
};